"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCustoHook = void 0;

var react_1 = require("react");

var hook_1 = require("../hook");

var errors_1 = require("../../utils/errors");

function buildCustoHook(hook, path, defaultValue) {
  return hook_1.CustoHook.createRawDataHook(function () {
    var _a;

    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var val = useVl(hook(), defaultValue, path);
    var value = val.use.apply(val, __spread(args));
    var isValueCustoHook = value instanceof hook_1.CustoHook;
    var isValueCustoHookRef = react_1.useRef(isValueCustoHook);

    if (isValueCustoHookRef.current !== isValueCustoHook) {
      isValueCustoHookRef.current = isValueCustoHook;
      throw new errors_1.HookChangeError("CustoHook must consistently return CustoHook or any value other than CustoHook. (path: " + path + "). Make sure to wrap your component with WrapInError helper function. Note: CRA still displays error in development mode; just press ESC do hide it");
    }

    if (value instanceof hook_1.CustoHook) {
      return (_a = useVl(value, defaultValue, path)).use.apply(_a, __spread(args));
    }

    return value;
  });
}

exports.buildCustoHook = buildCustoHook;

var useVl = function useVl(val, defaultValue, path) {
  if (val === undefined && defaultValue !== undefined) {
    val = defaultValue;
  }

  if (!(val instanceof hook_1.CustoHook)) {
    if (typeof val !== "function") {
      throw new errors_1.CustoTypeError("expected function or CustoHook at path " + path + ". received " + val);
    }

    var newVal = hook_1.CustoHook.createHook(val);
    val = newVal;
  }

  var dependency = val.unsafelyGetOriginalFn();
  var dependencyRef = react_1.useRef(dependency);

  if (dependencyRef.current !== dependency) {
    // hook has been changed
    if (!val.isSafe) {
      throw new errors_1.HookChangeError("hook changed in CustoHook. (path: " + path + "). Make sure to wrap your component with WrapInError helper function. Note: CRA still displays error in development mode; just press ESC do hide it");
    }
  }

  dependencyRef.current = dependency;
  return val;
};